import { Component, OnInit } from '@angular/core';
import { NavNode, NAV_DATA } from './nav-data';

@Component({
    selector: 'ip-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class IpNavComponent implements OnInit {
	nodes: NavNode[] = NAV_DATA;
	constructor() {}

	ngOnInit() {}
}
